var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2998 21.3501C12.1356 21.3503 11.9731 21.318 11.8214 21.2551C11.6697 21.1923 11.532 21.1001 11.4161 20.9838L6.61627 16.1841C6.49912 16.0682 6.40602 15.9304 6.34233 15.7785C6.27863 15.6266 6.2456 15.4635 6.24512 15.2988C6.24465 15.1341 6.27674 14.9709 6.33956 14.8186C6.40238 14.6663 6.49469 14.5279 6.61117 14.4115C6.72765 14.295 6.86601 14.2027 7.0183 14.1398C7.17058 14.077 7.33378 14.0449 7.49851 14.0454C7.66325 14.0458 7.82626 14.0789 7.97819 14.1425C8.13011 14.2062 8.26795 14.2993 8.38377 14.4165L12.2998 18.3325L21.6163 9.01608C21.8508 8.78249 22.1685 8.6515 22.4995 8.65186C22.8306 8.65221 23.148 8.78388 23.382 9.01797C23.6161 9.25205 23.7477 9.56944 23.7481 9.90048C23.7484 10.2315 23.6174 10.5492 23.3838 10.7837L13.1836 20.9839C13.0677 21.1002 12.9299 21.1923 12.7782 21.2552C12.6266 21.318 12.464 21.3503 12.2998 21.3501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.028e1e8d95d80b3630d3da1f44d7404d.svg";
export { ForwardRef as ReactComponent };